import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function checkSeatsAndSteeringWheelBadges_a5() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}


function addListeners_a5(frontCheckboxesMap, modalsCheckboxesMap) {
    frontCheckboxesMap['Q8H_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_a5(frontCheckboxesMap)
		}
		getPackageImages_a5('Q8H_A5', frontCheckboxesMap)
	})

	frontCheckboxesMap['0UD_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0UD_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_a5(frontCheckboxesMap)
		}
		getPackageImages_a5('0UD_A5', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['7TZ_A5'].addEventListener('change', function () {
			checkSubmit(frontCheckboxesMap)
			saveStateWithAjax('7TZ_A5', this.checked);
			if (this.checked) {
				//If we dont come from the modal
	
			} else {
				checkLocks_a5(frontCheckboxesMap)
			}
			getPackageImages_a5('7TZ_A5', frontCheckboxesMap)
		})

    
	frontCheckboxesMap['FZ9_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ9_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ8_A5'].checked == false) { 
				frontCheckboxesMap['FZ8_A5'].disabled = true
			}
		} else {
			checkLocks_a5(frontCheckboxesMap)
		}
		getPackageImages_a5('FZ9_A5', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['FZ8_A5'].addEventListener('change', function () {		

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ8_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ9_A5'].checked == false) { 
				frontCheckboxesMap['FZ9_A5'].disabled = true
			}
		} else {
			checkLocks_a5(frontCheckboxesMap)
		}
		getPackageImages_a5('FZ8_A5', frontCheckboxesMap)
	})	


    frontCheckboxesMap['0TF_A5'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0TF_A5', this.checked);
		if (this.checked) {
			//If we dont come from the modal
		} else {
			checkLocks_a5(frontCheckboxesMap)
		}
		getPackageImages_a5('0TF_A5', frontCheckboxesMap)
	})


}

/**Controls frontcheckboxes disable */
function checkLocks_a5(frontCheckboxesMap) {
    //DEFINE UNLOCK CONDITIONS	
	const unlockConditionForQ8H_7HH = true
	const unlockConditionFor0UD = true
	const unlockConditionFor7TZ = true
	
	const unlockConditionForFZ8 = !frontCheckboxesMap['FZ9_A5'].checked
	const unlockConditionForFZ9 = !frontCheckboxesMap['FZ8_A5'].checked
    
	const unlockConditionFor0TF = true

	frontCheckboxesMap['Q8H_A5'].disabled = !unlockConditionForQ8H_7HH
	frontCheckboxesMap['0UD_A5'].disabled = !unlockConditionFor0UD
	frontCheckboxesMap['7TZ_A5'].disabled = !unlockConditionFor7TZ
	
	frontCheckboxesMap['FZ8_A5'].disabled = !unlockConditionForFZ8
	frontCheckboxesMap['FZ9_A5'].disabled = !unlockConditionForFZ9
	
	//frontCheckboxesMap['0TF_A5'].disabled = !unlockConditionFor0TF
}


/**Gets images for all packages depending on selected packages */

function getImages_a5(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_a5(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_a5(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


export { addListeners_a5, saveStateWithAjax, checkLocks_a5, getImages_a5, getPackageImages_a5, checkSeatsAndSteeringWheelBadges_a5}

